import {z} from 'zod';

/**
 * Control type for a user variable — drives the UI input affordance.
 * `list` is a list of strings (e.g. URLs, keywords).
 * `domain` renders like `url` but the Designer prefills it with the
 * current site's primary domain.
 */
export const workflowUserVariableTypeSchema = z.enum([
  'shortText',
  'longText',
  'list',
  'url',
  'domain',
  'recommendationId',
  'collectionId',
  'slackChannelId',
]);
export type WorkflowUserVariableType = z.infer<
  typeof workflowUserVariableTypeSchema
>;

/**
 * Declaration of a user-editable variable for a workflow template.
 *
 * Declared in the template JSON under `webflow.variables[]`. Drives the
 * Run-now form on the client.
 */
export const workflowUserVariableDeclarationSchema = z.object({
  key: z.string().min(1),
  displayName: z.string().min(1),
  type: workflowUserVariableTypeSchema,
  defaultValue: z.union([z.string(), z.array(z.string())]).default(''),
  description: z.string().optional(),
  required: z.boolean().default(false),
});
export type WorkflowUserVariableDeclaration = z.infer<
  typeof workflowUserVariableDeclarationSchema
>;
